// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const GroundingRemoveResourceContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-groundingremoveresourcecontainer" */ "./GroundingRemoveResourceContainer")).then((bundle)=>{
        return {
            default: bundle.GroundingRemoveResourceContainer
        };
    });
export const LazyGroundingRemoveResourceContainer = /*#__PURE__*/ lazy(GroundingRemoveResourceContainerLazyLoader);
